import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
export default class VirtualAnchoredDelayActionMetadata extends Record({
  actionType: ActionTypes.VIRTUAL_SCHEDULED_ENROLLMENT,
  enrollmentSchedule: null
}, 'VirtualAnchoredDelayActionMetadata') {}